import Vue from "vue";
import "./plugins/vuetify";
import Vuetify from "vuetify";
import App from "./App.vue";
import router from "./router";
import store from "./store";

// index.js or main.js
import "vuetify/dist/vuetify.min.css";
import VeeValidate, { Validator } from "vee-validate";
import de from "vee-validate/dist/locale/de";
import moment from "moment";

Vue.config.productionTip = false;
Vue.use(Vuetify);
Vue.use(VeeValidate, {
  // mode: 'eager'
});
Validator.localize("de", de);

Vue.filter("datum", function(value, format) {
  if (value) {
    format = format || "DD.MM.YYYY";
    return moment(String(value)).format(format);
  }
});

Vue.filter("gewicht", function(value) {
  if (value) {
    return value.toFixed(2);
  }
});

new Vue({
  router,
  store,
  render: h => h(App),
  mounted() {
    document.title = process.env.VUE_APP_TITLE;
  },
  watch: {
    $route(to) {
      document.title = to.name + " | " + process.env.VUE_APP_TITLE;
    }
  }
}).$mount("#app");

console.info('Goldbuch - Zahn Wolf Freiburg');
